import React, { Component } from 'react';
import { SORT_ASC } from 'ra-core/lib/reducer/admin/resource/list/queryReducer';
import { connect } from 'react-redux';

import { Close } from '@material-ui/icons';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';

import Refresh from '../../../components/Refresh';
import {
  restClient, dateIntervalsGenerator, getDateString, aggregateSum, aggregatePercentages, getDateByDayId
} from '../../../common';
import CustomerDatagrid from './Datagrid';
import EjectedList from '../../../components/ejected/List';

import Edit1Component from './Edit';
import DateIntervals from '../../../components/DateIntervals';
import Header from './Header';
import CreateClient from './CreateClient';
import EditClient from '../clients/EditClient';
import { refreshView as refreshViewAction } from 'react-admin';
import { triggerCreate as triggerCreateAction, triggerEdit as triggerEditAction } from '../../../redux/actions';

class List extends Component {

  constructor(props) {
    super(props);
    this.state = {
      filter: {
        company: 'all',
        'date-from': getDateByDayId(0).toISOString(),
        'date-to': getDateByDayId(0, true).toISOString()
      },
      currentDateInterval: 51,
      dateIntervals: dateIntervalsGenerator(),
      createClientOpen: false,
      editClientOpen: false
    };

    restClient('GET_CUSTOM_POST', 'getCompanyDateIntervalsCount', {
      companyId: 'all',
      dateIntervals: this.state.dateIntervals
    }).then(res => {
      this.setState({
        dateIntervals: res.dateIntervals
      });
    });
  }

  toggleCreateClient = (open, record) => () => {
    this.setState({
        record: record,
        createClientOpen: open
      }
    );
  };

  toggleEditClient = (open, record, needFetch = false) => () => {
    if (needFetch) {
      restClient('GET_CUSTOM', 'clients/'+record.id).then(fetchedRecord => {
        this.setState({
            record: fetchedRecord.data,
            editClientOpen: open
          }
        );
      });
    } else {
      this.setState({
          record: record,
          editClientOpen: open
        }
      );
    }

  };

  submit = values => {
    restClient('GET_CUSTOM_POST', 'clients', values).then(res => {
      // todo refactor
      this.setState({
          // record: record,
          createClientOpen: false,
          editClientOpen: false
        }
      );
      this.props.refreshView();
    });
  };

  getCloseBtn = (click) => (
    <div onClick={click} style={{position: 'fixed', right: '31px', top: '65px', cursor: 'pointer' }}>
      <Close style={{fill: '#2c9bc3', width: '30px', height: '30px' }}/>
    </div>
  );

  getCloseBtn2 = (click) => (
    <div onClick={click} style={{position: 'fixed', right: '22px', top: '59px', cursor: 'pointer' }}>
      <Close style={{fill: '#2c9bc3', width: '30px', height: '30px' }}/>
    </div>
  );

  getCurrentCompany() {
    if (this.state.filter.company === 'all') {
      return {
        balance: aggregateSum(this.props.companies, 'balance'),
        count: aggregateSum(this.props.companies, 'count'),
        ctr: aggregatePercentages(this.props.companies),
        id: 'all',
        name: 'Все компании',
        noanswer: aggregateSum(this.props.companies, 'noanswer'),
        payments: aggregateSum(this.props.companies, 'payments'),
        rejected: aggregateSum(this.props.companies, 'rejected'),
        sum: aggregateSum(this.props.companies, 'sum'),
        verified: aggregateSum(this.props.companies, 'verified'),
        visited: aggregateSum(this.props.companies, 'visited'),
        treaty: aggregateSum(this.props.companies, 'treaty'),
      };
    }
    const companyIndex = this.props.companies.findIndex(i => i.id === this.state.filter.company);
    return this.props.companies[companyIndex];
  }

  onDateChange(key) {
    this.setState({
      filter: {
        ...this.state.filter,
        'date-from': this.state.dateIntervals[key].from,
        'date-to': this.state.dateIntervals[key].to
      },
      currentDateInterval: key
    });
  }

  getCompanyName() {
    const id = this.state.filter.company;
    if (id === 'all') {
      return 'Все компании';
    }
    return this.props.companies.find(company => company.id === this.state.filter.company).name;
  }

  getTitle(companies, filter) {
    if (companies.length && filter && filter.company && filter['date-to']) return `Записи на ${getDateString(new Date(filter['date-to']))}`;
    if (companies.length && filter && filter.company) return `Записи в ${this.getCompanyName()} `;
    if (filter && filter['date-to']) return `Записи на ${getDateString(new Date(filter['date-to']))}, `;
    return 'Записи, ';
  }

  render() {
    const defaultValues = {
      time: this.state.dateIntervals[this.state.currentDateInterval] ? this.state.dateIntervals[this.state.currentDateInterval].to : (new Date()).toISOString()
    };

    const passedProps = { ...this.props };
    delete (passedProps.refreshToken);
    delete (passedProps.refreshView);

    if (this.state.filter.company !== 'all') {
      defaultValues.companyId = this.state.filter.company;
    } else {
      defaultValues.companyId = '5b54dd4d791a93dcdc1999d7';
    }

    const createClient = (handleSubmit, record) => <CreateClient onSubmit={handleSubmit} record={record} companies={this.props.companies}/>;
    const editClient = (handleSubmit, record) => <EditClient onSubmit={handleSubmit} record={record} companies={this.props.companies}/>;
    const edit = (handleSubmit, record) => <Edit1Component onSubmit={handleSubmit} record={record} companies={this.props.companies} subjects={this.props.subjects}/>;

    return (
      <div className="col-wrapper">
        <SwipeableDrawer
          anchor="right"
          open={this.state.createClientOpen}
          onClose={this.toggleCreateClient(false)}
          onOpen={() => {}}
        >
          <div
            role="button"
          >
            {createClient(this.submit.bind(this), this.state.record)}
            { this.getCloseBtn(this.toggleCreateClient(false)) }
          </div>
        </SwipeableDrawer>

        <SwipeableDrawer
          anchor="right"
          open={this.state.editClientOpen}
          onClose={this.toggleEditClient(false)}
          onOpen={() => {}}
          disableSwipeToOpen
          disableBackdropTransition
          PaperProps={{style:{backgroundColor: '#F9F9F9'}}}
        >
          {editClient(this.submit.bind(this), this.state.record)}
          { this.getCloseBtn2(this.toggleEditClient(false)) }
        </SwipeableDrawer>

        <DateIntervals
          currentDateInterval={this.state.currentDateInterval}
          dateIntervals={this.state.dateIntervals}
          onDateChange={this.onDateChange.bind(this)}
        />
        <EjectedList
          {...passedProps}
          title={this.getTitle(this.props.companies, this.state.filter)}
          sort={{ field: 'time', order: SORT_ASC }}
          perPage={50}
          actions={<Refresh />}
          filter={this.state.filter}
          bulkActions={false}
          style={{ width: '1024px' }}
          headercomponent={Header}
          companies={this.props.companies}
          currentCompany={this.getCurrentCompany()}
        >
          <CustomerDatagrid
            edit={edit}
            companies={this.props.companies}
            callcenters={this.props.callcenters}
            subjects={this.props.subjects}
            toggleCreate={this.toggleCreateClient.bind(this)}
            toggleEdit={this.toggleEditClient.bind(this)}
          />
        </EjectedList>
      </div>
    );
  }
}

export default connect(state => ({
  // refreshToken: state.sc.refreshToken,
  companies: state.sc.companies,
  callcenters: state.sc.callcenters,
  subjects: state.sc.subjects
}), {
  refreshView: refreshViewAction,
})(List);




// WEBPACK FOOTER //
// ./src/pages/company/customer/List.js